exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".steps[data-v-2e1f34d9] {\n  max-width: 750px;\n  margin: 16px auto;\n}\n", ""]);

// exports
